import { Component, computed, ElementRef, HostListener, inject, ViewChild } from '@angular/core';
import { AppMenuComponent } from './app.menu';
import { AppModuleSelectorMobileComponent } from './app.module-selector-mobile';
import { ButtonModule } from 'primeng/button';
import { Router, RouterModule } from '@angular/router';

import { LayoutService } from '@layout/service/layout.service';
import { TenantLogoComponent } from '@shared/components/tenant-logo/tenant-logo.component';
import { KerepLogoComponent } from '@shared/components/kerep-logo/kerep-logo.component';
import { KEREP_PRODUCT } from '@shared/constants/brand.constants';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-sidebar]',
  standalone: true,
  imports: [
    AppMenuComponent,
    AppModuleSelectorMobileComponent,
    ButtonModule,
    RouterModule,
    TenantLogoComponent,
    KerepLogoComponent,
  ],
  template: `
    <div class="sidebar-header">
      <a [routerLink]="['/']" class="app-logo" style="cursor: pointer">
        <div class="app-logo-small">
          <shared-tenant-logo [width]="70" [className]="'!inline-block'" />
        </div>
        <div class="app-logo-normal">
          <shared-tenant-logo [width]="150" [className]="'!inline-block'" />
        </div>
      </a>
      <button
        class="layout-sidebar-anchor z-20"
        type="button"
        aria-label="Alternar fijación de barra lateral"
        (click)="onAnchorToggle()"
      ></button>
    </div>

    <!-- Selector de módulos para móviles -->
    <app-module-selector-mobile></app-module-selector-mobile>

    <div app-menu></div>

    <!-- Firma de Kerep al pie. El logo del tenant encabeza el sidebar; aquí firma el
         producto, que es la otra capa (ver docs/modules/BRAND_GUIDE.md). Sin versión ni autoría:
         eso ya está en el pie de página y en el menú de perfil. Las dos variantes se
         alternan por CSS en _sidebar_footer.scss según el modo de menú. -->
    <div class="sidebar-footer">
      <div class="sidebar-brand font-kerep">
        <span class="sidebar-brand-normal">
          <shared-kerep-logo variant="lockup" [product]="brandProduct" [size]="24" />
        </span>
        <span class="sidebar-brand-small">
          <shared-kerep-logo [size]="24" />
        </span>
      </div>
    </div>
  `,
  host: {
    class: 'layout-sidebar',
  },
})
export class AppSidebarComponent {
  protected get brandProduct(): string {
    return KEREP_PRODUCT;
  }

  el = inject(ElementRef);

  router = inject(Router);

  layoutService = inject(LayoutService);

  @ViewChild(AppMenuComponent) appMenu!: AppMenuComponent;

  logo = computed(() => (this.layoutService.isDarkTheme() ? 'light' : 'dark'));

  timeout!: ReturnType<typeof setTimeout> | null;

  onAnchorToggle() {
    this.layoutService.layoutState.update((val) => ({ ...val, anchored: !val.anchored }));
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.layoutService.layoutState().anchored) {
      if (this.timeout) {
        this.timeout = null;
      }
      this.layoutService.layoutState.update((val) => ({ ...val, sidebarActive: true }));
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (!this.layoutService.layoutState().anchored) {
      if (!this.timeout) {
        this.timeout = setTimeout(() => {
          this.layoutService.layoutState.update((val) => ({ ...val, sidebarActive: false }));
          this.timeout = null;
        }, 300);
      }
    }
  }
}
